export default __webpack_public_path__ + "static/media/splash-screen-line-hero.501a3f7d.svg";